// Libraries
import React, { forwardRef } from 'react'

// Styles
import { HeaderLogo, Wrap, Hr, HrMobile } from './style'
import { ContentWrap } from '../../style'

export const Header = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <Wrap>
      <ContentWrap>
        <HeaderLogo alt='YACHTCHARTERFINDER Logo'
                    src='/logo.svg'
                    onClick={() => window.open('https://99chartertipps.yachtcharterfinder.com/', '_blank')}
                    initial={{ y: -100, opacity: .6}}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 300, opacity: 0 }}
                    transition={{ duration: 1 }}/>
        <Hr initial={{ width: 0, opacity: .6}}
            animate={{ width: '100%', opacity: 1 }}
            exit={{ width: 0, opacity: 0 }}
            transition={{ duration: 2,  ease: 'easeInOut' }}/>
      </ContentWrap>
      <HrMobile initial={{ width: 0, opacity: .6}}
          animate={{ width: '100%', opacity: 1 }}
          exit={{ width: 0, opacity: 0 }}
          transition={{ duration: 1,  ease: 'easeInOut' }}/>
    </Wrap>
  );
})
